// extracted by mini-css-extract-plugin
export default {"btn_wrap":"instudyroompostmodal_btn_wrap__CkNce"};